module.exports = __webpack_public_path__ + "sign-on-widget-spinner.eea28db2b98f4df40b56.gif";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/img/ui/indicators/sign-on-widget-spinner.gif
// module id = ../../../../@okta/okta-signin-widget/dist/img/ui/indicators/sign-on-widget-spinner.gif
// module chunks = 11